// Main Slider
$('.mainSliderMotion').slick({
  dots: true,
  infinite: false,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  lazyLoad: 'ondemand',
});

// Product Slider
$('.productsSlider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  lazyLoad: 'ondemand',
  pauseOnHover:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

// Mobile Menu
$('.humburgerIcon').click(function(){
  $('.mobileMenu').toggleClass('showMenu');
  $('body').toggleClass('scrollHide');
})

$('.childMenu i.fa').click(function(){
  $(this).parent('.childMenu').children('.subMenu').toggle();
})

// Category Tabs
function tabsCat(totatlTabs, activeTab) {
  document.getElementById('allCatTabs').querySelector('.activeCat').removeAttribute('class');
  if(document.getElementById(activeTab)) document.getElementById(activeTab).setAttribute('class', 'activeCat');
  for(var i=0; i<totatlTabs; i++) document.getElementById('tb'+ i +'_c').style.display = 'none';
  if(document.getElementById(activeTab +'_c')) document.getElementById(activeTab +'_c').style.display = 'block';
}

var ultabs = document.getElementById('allCatTabs').querySelectorAll('li');
var nr_ultabs = ultabs.length;

if(sessionStorage.getItem('activetab')) {
  tabsCat(nr_ultabs, sessionStorage.getItem('activetab'));
}

for(var i=0; i<nr_ultabs; i++) ultabs[i].addEventListener('click', function(){
  tabsCat(nr_ultabs, this.id);
  sessionStorage.setItem('activetab', this.id);
}, false);

$('.headerSearch').click(function(){
	$('#searchbox').toggle();
})